/** 商品类型：与内购/商品配置一致，接口多为 value 字符串，展示需映射为 label */
export interface ProdTypeOptionItem {
  label: string
  describtion: string
  value: string
}

export const prodTypeOptions: ProdTypeOptionItem[] = [
  {
    label: '消耗型',
    describtion: '如"金币"、"钻石"等可消耗的商品；',
    value: '20',
  },
  {
    label: '非消耗型',
    describtion: '如"去广告"等只能购买一次的商品；',
    value: '10',
  },
  {
    label: '订阅型',
    describtion: '',
    value: '30',
  },
  {
    label: '非自动续期订阅',
    describtion: '如"VIP月卡”，到期后不自动续费；',
    value: '31',
  },
  {
    label: '自动续期订阅',
    describtion: '如"VIP月卡”，到期后自动续费，直至用户取消订阅；',
    value: '32',
  },
]

export function getProdTypeLabel(val: unknown): string {
  if (val === null || val === undefined || val === '') return '--'
  const s = String(val)
  const found = prodTypeOptions.find((o) => o.value === s)
  return found?.label ?? s
}
